import React, { useState, useEffect } from "react";
import { testimonials } from "../../data/mockData";
import { Star, ChevronLeft, ChevronRight } from "lucide-react";
import useInView from "../../hooks/useInView";

const TestimonialsCarousel = () => {
  const [testimonialsRef, testimonialsInView] = useInView();
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section ref={testimonialsRef} className="py-24 bg-[#1B2A4A] relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#C9A96E] rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#C9A96E] rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" />
      </div>

      <div
        className={`max-w-4xl mx-auto px-6 lg:px-12 text-center relative z-10 transition-all duration-700 ${
          testimonialsInView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <span className="text-[#C9A96E] text-sm font-medium tracking-[0.2em] uppercase">
          Testimonials
        </span>
        <h2 className="text-4xl md:text-5xl font-serif font-bold text-white mt-3 mb-16">
          What Our Guests Say
        </h2>

        <div className="relative">
          <div className="min-h-[200px]">
            {testimonials.map((t, i) => (
              <div
                key={t.name}
                className={`absolute inset-0 transition-all duration-700 ${
                  i === currentTestimonial
                    ? "opacity-100 translate-x-0"
                    : i < currentTestimonial
                    ? "opacity-0 -translate-x-full"
                    : "opacity-0 translate-x-full"
                }`}
              >
                <div className="flex justify-center gap-1 mb-6">
                  {Array.from({ length: t.rating }).map((_, si) => (
                    <Star
                      key={si}
                      size={20}
                      className="text-[#C9A96E] fill-[#C9A96E]"
                    />
                  ))}
                </div>
                <blockquote className="text-xl md:text-2xl text-white/90 font-serif italic leading-relaxed mb-8">
                  "{t.text}"
                </blockquote>
                <div>
                  <div className="text-white font-semibold">{t.name}</div>
                  <div className="text-[#C9A96E] text-sm">{t.event}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="flex justify-center gap-3 mt-12">
            <button
              onClick={() =>
                setCurrentTestimonial(
                  (currentTestimonial - 1 + testimonials.length) % testimonials.length
                )
              }
              className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white/60 hover:text-white hover:border-white/40 transition-colors"
            >
              <ChevronLeft size={18} />
            </button>
            {testimonials.map((t, i) => (
              <button
                key={t.name}
                onClick={() => setCurrentTestimonial(i)}
                className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                  i === currentTestimonial
                    ? "bg-[#C9A96E] w-8"
                    : "bg-white/30 hover:bg-white/50"
                }`}
              />
            ))}
            <button
              onClick={() =>
                setCurrentTestimonial((currentTestimonial + 1) % testimonials.length)
              }
              className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white/60 hover:text-white hover:border-white/40 transition-colors"
            >
              <ChevronRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export { TestimonialsCarousel };
